import useFormatDateTime from '@/utils/hooks/format/useFormatDateTime';
import useUser from '@/utils/hooks/swr/useUser';

import { classNames } from '@/utils/classNames';

interface MessageDateProps {
    date: string;
    className?: string;
}

export const MessageDate = ({ date, className }: MessageDateProps) => {
    const { user } = useUser();
    const { formatDateTimeNoTz } = useFormatDateTime(
        user?.settings?.timezone,
        user?.settings?.platform_language
    );

    return (
        <span className={classNames('!text-xxs uppercase text-icoGray-400', className)}>
            {formatDateTimeNoTz(date, 'weekDay_day_month_year_hour_minute')}
        </span>
    );
};
